export default {
  setFetchedAps: (state, _boo) => {
    state.isFetchedAps = _boo;
  },
  setPayloadServidorAps: (state, _payload) => {
    state.payloadServidorAps = _payload;
  },
  setPayloadCliente: (state, _payload) => {
    state.payloadCliente = _payload;
  },
  setHabilitarQuestionarioAps: (state, _boo) => {
    state.habilitarQuestionarioAps = _boo;
  },
  clearDataAps: state => {
    state.payloadServidorAps = {};
    state.payloadCliente = {};
  },
  setTemAps: (state, _boo) => {
    state.temAps = _boo;
  },
  setPuxarCliente: (state, _boo) => {
    state.puxarCliente = _boo;
  },
  setUnimed: (state, _string) => {
    state.unimed = _string;
  },
  setProntuarios: (state, _payload) => {
    state.listaProntuarios = _payload;
  }
};
